import React, { useReducer } from 'react';
import details from './reducers/details';
import boards from './reducers/boards';
import { DetailsContext, ListContext } from './context';

export const withListContext = Wrapped => (props) => {
    const { reducer = boards, ...rest } = props;
    const { isHistory = false, leaderboardIds } = rest;

    const [state, dispatch] = useReducer(reducer, {
        isHistory,
        isCustom: Boolean(leaderboardIds)
    });

    return <ListContext.Provider value={{ state, dispatch }}>
        <Wrapped {...rest} />
    </ListContext.Provider>;
};

export const withDetailsContext = Wrapped => (props) => {
    const { reducer = details, ...rest } = props;
    const { leaderboardId } = rest;
    const [state, dispatch] = useReducer(reducer, {
        leaderboardId: Number(leaderboardId)
    });

    return <DetailsContext.Provider value={{ state, dispatch }}>
        <Wrapped {...rest} />
    </DetailsContext.Provider>;
};
